// extracted by mini-css-extract-plugin
module.exports = {"loaderFixedContainer":"Loader_loaderFixedContainer__1-nXV","loadingAnimation":"Loader_loadingAnimation__GWusJ","loading-animation":"Loader_loading-animation__2yREi"};